<template>
  <div class="row">
    <div class="col-md-6 offset-md-3">
      <alert show variant="success" v-if="resetSuccess">
        {{ $t("password_activation_success") }}
      </alert>

      <alert show variant="danger" v-if="errorMessage">
        {{ $t(errorMessage) }}
      </alert>

      <p class="text-center">
        <btn
          v-if="resetSuccess"
          to="/user/login"
          icon="unlock"
          title="Zaloguj się"
          variant="primary"
        />
      </p>
    </div>
  </div>
</template>

<script>
import UserApi from "@/api/User";

export default {
  name: "UserForgotPassword",
  data() {
    return {
      email: process.env.VUE_APP_SUPPORT_MAIL,
      contactUrl: process.env.VUE_APP_CONTACT,
      errorMessage: "",
      resetSuccess: false
    };
  },
  async created() {
    const hash = this.$route.params.hash;
    const userId = this.$route.params.userId;

    const activation = await UserApi.activatePassword(userId, hash).then(
      res => res
    );

    this.errorMessage = activation.message;
    this.resetSuccess = activation.success;

    // const created = await UserApi.activatePassword(userId, hash);
  }
};
</script>
